<template>

    <nav class="client-menu clearfix" id="clientMenu">

        <div @click="toggleMenu" class="client-menu-btn"><span>{{ $t('main_menu.menu')}}</span> <font-awesome-icon icon="align-justify" /></div>

        <ul v-if="showClientMenu">
            <li><router-link :to="{ name: 'dashboard' }" class="smooth-menu">{{ $t('main_menu.welcome')}}</router-link></li>
            <li><router-link :to="{ name: 'therapy' }" class="smooth-menu">{{ $t('main_menu.courses')}}</router-link></li>
            <li v-if="Object.keys(checkForum).length > 0 && activeEnrollment"><router-link :to="{ name: 'forums' }" class="smooth-menu bg-success rounded mt-1 mb-1">{{$t('forums.forum')}} </router-link></li>
            <li><router-link :to="{ name: 'messages' }" class="smooth-menu">{{ $t('main_menu.messages')}} <span class="badge badge-light align-middle" v-if="inboxUnread">{{ inboxUnread }}</span></router-link></li>
            <li><router-link :to="{ name: 'profile' }" class="smooth-menu">{{ $t('main_menu.profile')}}</router-link></li>
            <li v-if="$appConfig['allow_videos'] && showGlobalVideos"><router-link :to="{ name: 'videos' }" class="smooth-menu">{{ $t('main_menu.videos')}}</router-link></li>
            <li><router-link :to="{ name: 'logout' }" class="smooth-menu">{{ $t('main_menu.log_out')}} <font-awesome-icon icon="sign-out-alt" /></router-link></li>
        </ul>
    </nav>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    data() {
        return {
            showClientMenu: true,
            windowWidth: window.innerWidth,
            isMobile: false
		};
    },
    created () {
        this.fetchForums({page: 1, per_page: 200});
        this.fetchEnrollments();
        this.getVideos({vtype: "global", clientId: this.currentUserId});
	},
    computed: {
		...mapGetters(["inboxUnread"]),

         checkForum () {
             return (this.$store.state.forums.forums) ? this.$store.state.forums.forums : {};  
         },
         activeEnrollment () {
            let enrollments = this.$store.state.programs.enrollments;
            if (enrollments) {
                let keys = Object.keys(enrollments);
                let active = [];
                keys.forEach( function ( enrolId ) {
                    if ( enrollments[enrolId].terminated_at == null && moment().isAfter(moment(enrollments[enrolId].starts_at)) && moment().isBefore(moment(enrollments[enrolId].ends_at)) )
                        active.push(enrollments[enrolId]);
                });
                return (active[0]) ? active[0] : false;
            }
            return false;
        },
        showGlobalVideos () {
            let videos = this.$store.state.videos.gloablVideos ;
            if (videos && Object.keys(videos).length) {
                return true;
            }
            else {
                return false;
            }
            
        },
        client_id () {
            return this.$store.state.auth.user.id;
        },
  	},
    mounted() {
        this.isMobile = (window.innerWidth <= 600) ? true : false;

        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        });
        this.getVideos({vtype: "global", clientId: this.currentUserId});
    },
    watch: {
        windowWidth (newWidth, oldWidth) {
            this.isMobile = (newWidth <= 600) ? true : false;
            this.showClientMenu = (newWidth <= 600) ? false : true;
        },
        $route (to, from) {
            if (this.isMobile && this.showClientMenu) this.showClientMenu = false;
        }
    },
    methods: {
        ...mapActions(["fetchForums", "fetchEnrollments", "getVideos"]),
        toggleMenu (e) {
            this.showClientMenu = !this.showClientMenu;
        }
    }
}
</script>
